define('modules/auth/forms/views/login.view',[
    'client',
    'jquery',
    'bootstrap',
    'underscore',
    'backbone',
    'moment',
    'modules/base/models/token.model',
    'text!modules/auth/forms/templates/login.template.html'
], function(
    Prospector,
    $,Bootstrap,_,Backbone,moment,
    CredentialsModel,
    LoginTemplate
    ){
    var LoginView = Backbone.View.extend({
        template:_.template(LoginTemplate),
        className: 'loginView container-fluid unAuthView loginv2',
        events:function() {
            var base = {
                'keyup #userEmail'      : 'procUpperCase',
                'blur #userEmail'       : 'clearMessages',
                'focus #userEmail'      : 'clearMessages',
                'keyup #userPwd'        : 'procKeyOnEnter'
            };
            var click = {
                    'click .btn'           : 'procForm'
                };
            $.extend(base,click);
            return base;
        },
        setURLError :"Login credentials incorrect",
        initialize: function() {
            this.debugName = 'login controller';
            window.auth = new CredentialsModel();
        },
        render: function() {
            $(this.el).html(this.template());
            this.$('#userNonce').val("");
            this.compatibility();
            this.buildCarousel();

            if(window.utils.readCookie("userName") != null){
                this.$('#userEmail').val(window.utils.readCookie("userName"))
            }

            return this;
        },

        buildCarousel:function(){
            if ($('body').hasClass('ieFix')){
                this.$("#ieGif").show();
                this.$(".ieSvg").hide();
            }
            for (var i = 0; i < this.$('.item').length; i++) {
                this.$(".carousel-indicators").append(' <div class="carousel-page" data-target="#myCarousel" data-slide-to="' + i + '"></div>')
            }

            this.$("#myCarousel").carousel({interval: 20000});
            var random = Math.floor(Math.random() * this.$(".item").length)
            this.$("#myCarousel").carousel(random);
            this.$('#myCarousel').on('slid.bs.carousel', $.proxy(function(){
                var darkBg = this.$('#myCarousel .item.smh-item').index();
                var currentIndexPop = this.$('#myCarousel .item.active').index();
                console.log(darkBg == currentIndexPop);
                if (darkBg == currentIndexPop) {
                    this.$(".carousel-pagers").addClass('dark-bg')
                } else {
                    this.$(".carousel-pagers").removeClass('dark-bg')
                }
            }, this));
            this.$(".carousel-page").eq(random).addClass("active");
        },

        compatibility: function(options){
            var browser = this.getBrowserInfo();
            var triggerAlert = true;
            switch(window.utils.browserName){
                case "Chrome":{
                    if(browser.version > 30){
                        triggerAlert = false;
                    }
                    break;
                }
                case "Firefox":{
                    if(browser.version > 33){
                        triggerAlert = false;
                    }
                    break;
                }
                case "Safari":{
                    if(browser.version > 6){
                        triggerAlert = false;
                    }
                    break;
                }
                case "Explorer":{
                    if(browser.version == undefined){
                        var split  = browser.split(" ");
                        if(split.length > 1 &&  split[1] > 10) {
                            triggerAlert = false;
                        }
                    } else if( window.utils.browserVersion > 10){
                        triggerAlert = false;
                    }
                    break;
                }
            }
            if(!triggerAlert){
                var check = false;
                (function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od|ad)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4)))check = true})(navigator.userAgent||navigator.vendor||window.opera);
                triggerAlert =  check;
            }

            if(triggerAlert){
                Prospector.trigger("showCompatability");
            }
        },
        getBrowserInfo:function(){
            var ua=navigator.userAgent,tem,M=ua.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || [];
            if(/trident/i.test(M[1])){
                tem=/\brv[ :]+(\d+)/g.exec(ua) || [];
                return 'IE '+(tem[1]||'');
            }
            if(M[1]==='Chrome'){
                tem=ua.match(/\bOPR\/(\d+)/)
                if(tem!=null)   {return 'Opera '+tem[1];}
            }
            M=M[2]? [M[1], M[2]]: [navigator.appName, navigator.appVersion, '-?'];
            if((tem=ua.match(/version\/(\d+)/i))!=null) {M.splice(1,1,tem[1]);}
            return {
                name: M[0],
                version: M[1]
            };
        },
        procKeyOnEnter: function(event) {
            var keypressed = event.keyCode || event.which;
            keypressed = (keypressed == 'undefined') ? window.event : keypressed;
            if (keypressed == 13) {
                this.procLogin();
            }
        },
        procUpperCase: function(event) {
            if (window.utils.validation.isCapsKey(event)) {
                this.$('.loadingMsg').html('E-mail address is case sensitive. Did you mean to enter upper case or have CAPS LOCK enabled?');
            }
        },
        clearMessages: function() {
            this.$('.loadingMsg').html('');
        },
        procForm: function() {
            switch(parseInt(this.$('#formType').val())){
                case 1:
                    this.procLogin();
                    break;
                default:
            }
        },
        procLogin: function() {
            window.utils.blurForm();
            this.$('.loadingMsg').html('');
            window.auth.set(
                {
                    userName      : this.$('#userEmail').val().trim(),
                    password   : this.$('#userPwd').val()
                }
            );
            // window.login.login();
            // if (window.login.isValid()){
            //     $.ajaxSetup({
            //         headers: {
            //             'userToken':this.$('#userNonce').val()
            //         }
            //     });
                this.$('.loadingMsg').html('Logging in...');
                this.$('.textLoader').addClass('orangeBtnLoader');
                window.auth.once('sync', this.procResponse,this);
                window.auth.save();
            // } else {
            //     this.$('.loadingMsg').html(window.login.errorMessage);
            //     this.$('.loadingMsg').removeClass('rightLoader');
            //     window.login.modelStatus = 100;
            // }
        },
        procResponse: function() {
            if(window.auth.has('error')){
                if(window.auth.get('error').status == -301){
                    window.auth.set({error: undefined});
                    window.token.once('sync', this.procToken, this);
                    window.token.fetch();
                }else{
                    this.$('.loadingMsg').html("Error: " + window.auth.get('error').message);
                    window.auth.set({error: undefined});
                }
                window.auth.modelStatus = 100;
            }else if (window.auth.has('name')) {
                window.setTimeout(function () {
                    var userToken = window.utils.readCookie('userToken');
                    $(".loadingMsg").html("Revving up our relationship intelligence engines...");
                    window.utils.createCookie('token', window.utils.readCookie('userToken'),0.01);
                    var cookieHost = window.auth.get('name');
                    if (window.location.href.toLowerCase().indexOf("relpro.com") > -1){
                        window.utils.createCookie("specifiedHost", cookieHost);
                    } else {
                        // cookieHost = "localhost";
                        // window.utils.createCookie("specifiedHost", "localhost");
                    }
                    window.location.href =  "http://" + cookieHost;
                }, 1000, this);
            }
        },
        procToken:function() {
            this.$('#userNonce').val(window.token.get('nonce'));
            this.procLogin();
        }
    });
    return LoginView;
});


